import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, Button, Box, Typography, IconButton } from "@mui/material";
import { FaPaperclip } from "react-icons/fa";
import CloseIcon from "@mui/icons-material/Close";

export default function DialogResponderAprovacao({
  aberto,
  resposta,
  onChangeResposta,
  onCancelar,
  onConfirmar,
  processando,
  titulo,
  contentText,
  pergunta,
  labelCampo = "Sua resposta",
  rows = 3,
  maxLength, // mantido por compatibilidade: o texto agora é livre
  labelConfirmar = "Responder",
  corConfirmar = "#1998a8",
  arquivo,
  onChangeArquivo,
}) {
  return (
    <Dialog open={aberto} onClose={onCancelar} maxWidth="md" fullWidth>
      <DialogTitle sx={{ backgroundColor: "var(--ig-f-1e1e1e)", color: "var(--ig-t-ffffff)" }}>{titulo}</DialogTitle>
      <DialogContent sx={{ backgroundColor: "var(--ig-f-1e1e1e)", pt: "20px !important", overflowX: "hidden" }}>
        {contentText && <DialogContentText sx={{ color: "var(--ig-t-aaaaaa)", mb: 2 }}>{contentText}</DialogContentText>}
        {pergunta && (
          <Box sx={{ p: 1.5, mb: 2, backgroundColor: "var(--ig-f-252525)", border: "1px solid var(--ig-b-333333)", borderRadius: 1 }}>
            <Typography sx={{ color: "var(--ig-t-888888)", fontSize: "0.75rem", fontWeight: 600, mb: 0.5 }}>Pergunta:</Typography>
            {/* Texto inteiro, quebrando linha mesmo em palavras longas (sem rolagem lateral) */}
            <Typography sx={{ color: "var(--ig-t-cccccc)", fontSize: "0.85rem", whiteSpace: "pre-wrap", wordBreak: "break-word", overflowWrap: "anywhere" }}>
              {pergunta}
            </Typography>
          </Box>
        )}
        <TextField
          autoFocus
          fullWidth
          multiline
          // Texto livre: campo maior, que cresce conforme a digitação.
          minRows={Math.max(rows, 8)}
          maxRows={20}
          label={labelCampo}
          value={resposta}
          onChange={(e) => onChangeResposta(e.target.value)}
          helperText={`${resposta.length} caracteres`}
          slotProps={{
            htmlInput: { style: { color: "var(--ig-t-ffffff)" } },
            inputLabel: { sx: { color: "var(--ig-t-888888)", "&.Mui-focused": { color: "var(--ig-t-64b5f6)" } } },
          }}
          sx={{
            "& .MuiOutlinedInput-root": { "& fieldset": { borderColor: "var(--ig-b-444444)" } },
            "& .MuiFormHelperText-root": { color: "var(--ig-t-888888)" },
          }}
        />
        {onChangeArquivo && (
          <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1 }}>
            <Button
              component="label"
              variant="contained"
              startIcon={<FaPaperclip />}
              size="small"
              sx={{ width: "auto", backgroundColor: "#007bff", fontWeight: 700, "&:hover": { backgroundColor: "#0069d9" }, textTransform: "none" }}
            >
              GED
              <input type="file" hidden onChange={(e) => onChangeArquivo(e.target.files?.[0] ?? null)} />
            </Button>
            {arquivo && (
              <>
                <Typography sx={{ color: "var(--ig-t-cccccc)", fontSize: "0.82rem" }}>{arquivo.name}</Typography>
                <IconButton size="small" onClick={() => onChangeArquivo(null)} sx={{ color: "var(--ig-t-888888)" }}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </>
            )}
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ backgroundColor: "var(--ig-f-1e1e1e)", pb: 2, pr: 2 }}>
        <Button onClick={onCancelar} sx={{ color: "var(--ig-t-888888)" }}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={onConfirmar}
          disabled={!resposta.trim() || processando}
          sx={{ backgroundColor: corConfirmar, textTransform: "none" }}
        >
          {labelConfirmar}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
